import { PromoUpdatePage } from '@/features/promo/pages/PromoUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/promo/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["promo.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PromoUpdatePage,
})
